import { useEffect, useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function TenantEnquiry() {
  const { slug } = useParams();
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const [form, setForm] = useState({
    customer_name: "", customer_phone: "", customer_email: "",
    service_id: sp.get("service_id") || "",
    preferred_date: "", preferred_slot: "",
    location: "", message: "",
  });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post(`/public/tenant/${slug}/enquiries`, form);
      toast.success(`Enquiry sent! Ref: ${r.data.code}`);
      nav(`/t/${slug}`);
    } catch (err) {
      toast.error("Failed to send enquiry");
    } finally { setLoading(false); }
  };

  const whatsappShare = () => {
    const msg = `Hi! I'm interested in a service.\nName: ${form.customer_name}\nPhone: ${form.customer_phone}\nLocation: ${form.location}\nMessage: ${form.message}`;
    window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, "_blank");
  };

  return (
    <div className="pwa-narrow px-5 py-5 md:py-8" data-testid="tenant-enquiry-page">
      <h1 className="brand-heading font-bold text-2xl md:text-3xl">Send enquiry</h1>
      <p className="text-sm brand-text-muted mt-1">Tell us what you need, we'll call back.</p>
      <form onSubmit={submit} className="mt-5 space-y-3">
        <Field label="Name" value={form.customer_name} onChange={(v) => setForm({ ...form, customer_name: v })} required testid="tenant-enquiry-name" />
        <Field type="tel" label="Phone" value={form.customer_phone} onChange={(v) => setForm({ ...form, customer_phone: v })} required testid="tenant-enquiry-phone" />
        <Field type="email" label="Email" value={form.customer_email} onChange={(v) => setForm({ ...form, customer_email: v })} testid="tenant-enquiry-email" />
        <Field label="Location / Area" value={form.location} onChange={(v) => setForm({ ...form, location: v })} testid="tenant-enquiry-location" />
        <div className="grid grid-cols-2 gap-2">
          <Field type="date" label="Preferred date" value={form.preferred_date} onChange={(v) => setForm({ ...form, preferred_date: v })} testid="tenant-enquiry-date" />
          <Field label="Preferred time" value={form.preferred_slot} onChange={(v) => setForm({ ...form, preferred_slot: v })} testid="tenant-enquiry-time" />
        </div>
        <div>
          <label className="text-xs uppercase tracking-wider font-semibold brand-text-muted">Message</label>
          <textarea value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} rows={3}
            data-testid="tenant-enquiry-message"
            className="w-full mt-1 brand-surface brand-text brand-border border rounded-xl px-4 py-3 text-base focus:outline-none" />
        </div>
        <button type="submit" disabled={loading} className="w-full brand-primary py-3.5 rounded-full font-semibold text-sm disabled:opacity-50" data-testid="tenant-enquiry-submit">
          {loading ? "Sending..." : "Send Enquiry"}
        </button>
        <button type="button" onClick={whatsappShare} className="w-full brand-muted brand-text py-3 rounded-full font-semibold text-xs">Share on WhatsApp</button>
      </form>
    </div>
  );
}

function Field({ label, value, onChange, required, type, testid }) {
  return (
    <div className="min-w-0">
      <label className="text-xs uppercase tracking-wider font-semibold brand-text-muted">{label}</label>
      <input type={type || "text"} value={value} onChange={(e) => onChange(e.target.value)} required={required}
        data-testid={testid}
        className="w-full mt-1 brand-surface brand-text brand-border border rounded-xl px-4 py-3 text-base focus:outline-none" />
    </div>
  );
}
